import type { TColor } from '@Theme';
import OwnableTheme from '@Theme';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';
import { View } from 'react-native';

import type { Size, Weight } from '../../Common/Text';
import { Text } from '../../Common/Text';

type IProductPriceProps = {
  price: number | null | undefined;
  weight?: Weight;
  size?: Size;
  gutterBottom?: number;
  color?: TColor;
};

const labelStyle: StyleProp<TextStyle> = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
  height: '100%',
  justifyContent: 'center',
  flexDirection: 'column',
};

const ProductPrice: FC<IProductPriceProps> = ({
  weight = 'regular',
  price,
  color = OwnableTheme.colors.persianIndigo,
  size = 'ml',
}) => {
  let priceString = null;

  if (price && price > 0) {
    priceString = `£${price.toFixed(2)}`;
  }

  return (
    <View>
      {priceString !== null && (
        <Text
          weight={weight}
          size={size}
          color={color}
          fontStyleOverride={labelStyle}
        >
          {priceString}
        </Text>
      )}
    </View>
  );
};

export default ProductPrice;
